<template>
  <div class="casedetail">
    <Nav></Nav>
    <div class="home-box">
      <div class="home-inner">
        <div style="position: relative">
          <div @click="handleBack">
            <div class="icon-back">
              <img src="@/assets/btn-totop.png" alt="" />
            </div>
          </div>
          <div>
            <div class="case-name-box">
              {{ detail ? detail.goods_name : "" }}
            </div>
            <div class="supply-collect-buttons" v-if="detail">
              <div
                :class="
                  detail && detail.saveData && detail.saveData.length
                    ? ['button', 'noClick']
                    : ['button', 'red']
                "
                @click="handleApply"
              >
                {{
                  detail && detail.saveData && detail.saveData.length
                    ? "已提交"
                    : "申请演示"
                }}
              </div>
              <div :class="['button', 'red']" @click="handleFavorite">
                {{
                  detail && detail.saveData001 && detail.saveData001.length
                    ? "取消收藏"
                    : "收藏"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="casedetail-wraper">
          <div class="casedetail-main-wraper">
            <!-- v-html="detail.content" -->
            <div v-if="detail">
              <img
                v-for="(item, idx) in detail.content"
                :key="idx"
                :src="item"
              />
            </div>
            <img
              v-if="showTopIcon"
              class="top-btn"
              src="../assets/btn-totop.png"
              alt="btn-totop"
              @click.stop="goTop"
            />
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <DialogApplyInfo
      ref="dialogApplyInfo"
      :title="'申请演示'"
      :goodData="goodData"
      @reloadList="reloadData"
      :id="applyinfoid"
    ></DialogApplyInfo>
    <DialogApplyFail
      ref="dialogApplyFail"
      :title="'申请演示'"
    ></DialogApplyFail>
    <ButtonFeedback></ButtonFeedback>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import VideoPlay from "@/components/VideoPlay";
import DialogApplyInfo from "@/components/dialog/ApplyInfo";
import DialogApplyFail from "../components/dialog/ApplyFail";
import ButtonFeedback from "@/components/ButtonFeedback";
import pageCommon from "@/utils/pagecommon";
import caseApi from "@/api/case";
import lodash from "lodash";
export default {
  name: "CaseDetail",
  components: {
    Swiper,
    SwiperSlide,
    Nav,
    Footer,
    VideoPlay,
    DialogApplyInfo,
    DialogApplyFail,
    ButtonFeedback,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      id: "",
      detail: null,
      goodData: null,
      showTopIcon: false,
      isRequesting: false,
      applyinfoid: 0,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let userInfo = _this.$store.state.user;
      return userInfo;
    },
    systemUser: function () {
      let _this = this;
      let systemUser = _this.$store.state.systemUser;
      return systemUser;
    },
  },

  mounted() {
    let _this = this;
    _this.$store.dispatch("acNavIndex", -1);
    window.addEventListener("scroll", _this.showToTop);
    _this.id = _this.$route.query.id;
    if (!_this.id) {
      // _this.$router.go(-1);
      return;
    }
    pageCommon.systemUserLogin().then(
      (res) => {
        _this.getCaseDetailInfo();
      },
      (err) => {}
    );
  },
  methods: {
    getCaseDetailInfo: function () {
      let _this = this;
      let seller_id = 300098;
      let requestData = {
        id: _this.id,
        seller_id: seller_id,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "getCaseDetail", requestData).then(
        (res) => {
          let detail =
            res.public_goods_list && res.public_goods_list.length
              ? res.public_goods_list[0]
              : null;
          if (!detail) {
            _this.$router.go(-1);
            return;
          }
          let goods_dec_pics = detail.goods_dec_pic
            ? detail.goods_dec_pic.split(",")
            : [];
          detail.content = goods_dec_pics;
          console.log(detail, "detail");
          _this.detail = detail;
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
          _this.detail = null;
          _this.$router.go(-1);
        }
      );
    },
    handleApply: function () {
      let _this = this;
      if (!_this.userInfo || _this.userInfo.id_public_user_info === 92) {
        _this.$message.warning("请先登录");
        this.$router.push("/login");
        return;
      }
      if (!_this.detail) {
        return;
      }
      // if (_this.detail && _this.detail.saveData && _this.detail.saveData.length) {
      console.log(!_this.detail);
      if (_this.detail) {
        // _this.goodData=item;
        console.log(_this.userInfo);
        _this.getMyApplies(_this.userInfo);
        /*if (_this.userInfo.user_remark_012 === '1202') {
          _this.$refs["dialogApplyInfo"].showDialog = true;
          if (
                  _this.detail.saveData.length &&
                  _this.detail.saveData[0].id_public_goods_order_detail
          ) {
            _this.applyinfoid =
                    _this.detail.saveData[0].id_public_goods_order_record;
          } else {
            _this.applyinfoid = 0;
          }
          _this.$nextTick(() => {
            _this.goodData = lodash.cloneDeep(_this.detail);
          });
        } else {

        }*/
      } else {
        _this.$refs["dialogApplyFail"].showDialog = true;
      }
    },

    getMyApplies: function (item) {
      let _this = this;
      let requestData = {
        idx: 0,
        limit: 1000,
        buyer_id: _this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "myApply", requestData).then(
        (res) => {
          console.log(res);
          if (res.order_list && res.order_list.length) {
            if (
              _this.userInfo.user_remark_012 &&
              _this.userInfo.user_remark_012 === "1202"
            ) {
              _this.handleSureApply(item);
            } else {
              _this.$refs["dialogApplyFail"].showDialog = true;
            }
          } else {
            _this.handleSureApply(item);
          }
        },
        (err) => {
          _this.collectList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },

    handleSureApply: function (item) {
      console.log(item);
      let _this = this;
      if (item.saveData && item.saveData.length) {
        return;
        _this.applyinfoid = item.saveData[0].id_public_goods_order_record;
      } else {
        _this.applyinfoid = 0;
      }

      _this.$refs["dialogApplyInfo"].showDialog = true;
      _this.$nextTick(() => {
        _this.goodData = lodash.cloneDeep(item);
      });
    },

    reloadData: function () {
      let _this = this;
      _this.getCaseDetailInfo();
    },
    handleBack() {
      if (this.$route.query.type === "-1") {
        this.$router.push({ path: "/mycollect" });
      } else if (this.$route.query.type === "-2") {
        this.$router.push({ path: "/myapply" });
      } else {
        this.$router.push({
          path: "/case",
          query: { type: this.$route.query.type },
        });
      }
    },
    showToTop: function () {
      let _this = this;
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 500
      ) {
        _this.showTopIcon = true;
      } else {
        _this.showTopIcon = false;
      }
    },
    goTop() {
      cancelAnimationFrame(this.timer);
      const self = this;
      self.timer = requestAnimationFrame(function fn() {
        const oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          self.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(self.timer);
        }
      });
    },
    handleFavorite: function () {
      let _this = this;
      if (!_this.userInfo || _this.userInfo.id_public_user_info === 92) {
        _this.$message.warning("请先登录");
        this.$router.push("/login");
        return;
      }
      if (_this.isRequesting) {
        return;
      }

      if (_this.detail.saveData001 && _this.detail.saveData001.length) {
        _this.delCollectCaseMain();
      } else {
        _this.collectCaseMain();
      }
    },
    collectCaseMain: function () {
      let _this = this;
      let id_public_user_info = _this.userInfo.id_public_user_info;
      let id_public_goods_info = _this.detail.id_public_goods_info;
      let data = {
        id_public_user_info: id_public_user_info,
        id_public_goods_info: id_public_goods_info,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "collectCase", data).then(
        (res) => {
          _this.$message.success("收藏成功");
          _this.isRequesting = false;
          _this.getCaseDetailInfo();
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    delCollectCaseMain: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      let id_public_user_info = _this.userInfo.id_public_user_info;
      let id_public_goods_info = _this.detail.id_public_goods_info;
      let id_public_middle_table =
        _this.detail.saveData001[0].id_public_middle_table;
      let data = {
        id_public_middle_table: id_public_middle_table,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "delCollectCase", data).then(
        (res) => {
          _this.$message.success("取消收藏成功");
          _this.isRequesting = false;
          _this.getCaseDetailInfo();
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
  },
  destroyed() {
    let _this = this;
    window.removeEventListener("scroll", _this.showToTop);
  },
};
</script>

<style scoped lang="less">
.casedetail {
  min-height: 100vh;
  overflow: hidden;
  background: #000000;
  display: flex;
  flex-direction: column;
  .home-box {
    position: relative;
    width: 100%;
    flex: 1;
    color: #ffffff;
    font-size: 30px;
    overflow: hidden;

    .home-inner {
      min-width: 1200px;
      padding-top: 80px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      box-sizing: border-box;
      .icon-back {
        position: absolute;
        left: 14.5%;
        top: 50%;
        width: 70px;
        height: 70px;
        background-color: transparent;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          width: 70px;
          line-height: 70px;
          transform: rotate(-90deg);
        }
      }
      .case-name-box {
        width: 100%;
        text-align: center;

        font-size: 32px;
        font-family: "SourceHanSansCN";
        color: rgb(255, 255, 255);
        line-height: 32px;
        padding-top: 80px;
        box-sizing: border-box;
      }
      .supply-collect-buttons {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        .button {
          border: 1px solid rgb(153, 153, 153);
          border-radius: 4px;
          width: 78px;
          height: 28px;
          line-height: 28px;

          font-size: 14px;
          font-family: "SourceHanSansCN";
          color: rgb(153, 153, 153);
          margin-left: 15px;
          cursor: pointer;
          &:first-child {
            margin-left: 0;
          }
          &.red {
            border-color: #ec4040;
            color: #ec4040;
          }
          &.noClick {
            pointer-events: none;
          }
        }
      }
      .casedetail-wraper {
        position: relative;
        width: 100%;
        margin: 40px auto;
        .casedetail-main-wraper {
          position: relative;
          width: 1200px;
          margin: 0 auto;
          /deep/ img {
            width: 100%;
            vertical-align: top;
            margin: 0;
            padding: 0;
          }
          .top-btn {
            position: fixed;
            width: 82px;
            height: 82px;
            // right: -102px;
            // right: 0;
            bottom: 300px;
            cursor: pointer;
            transform: translateX(620px);
          }
        }
      }
    }
  }
}
</style>
